import { BaseStore } from "./base_store";
// import { runInAction, makeAutoObservable } from "mobx"
// import UserAPI from "../api/user";
import IdentityAPI from "../api/identity_api";
import { Identity, IdentityProps }  from './identity_store';
import PresenceAPI from "../api/presence_api";


const TICK_INTERVAL = 10 * 1000;
const TIMEOUT_INTERVAL = 60 * 1000;

export class UserIdentityStore extends BaseStore<IdentityProps, Identity> {
    presenceTimeoutId = 0;
    presenceQueueId = 0;

    currentIdentityKey = "";

    presenceLastActive = new Date();
    presenceUpdateCount = 0;

	async createIdentity(identity: Identity) {
        console.log("createIdentity: %o", identity);

		return IdentityAPI.create(identity.name,
            identity.email,
            identity.color,
            identity.role,
            identity.verified,
            identity.phone,
            identity.addr1,
            identity.addr2,
            identity.city,
            identity.state,
            identity.zipcode).then((resp) => {
            this.receiveUpdate([resp]);
            return resp;
        });
	}

    async updateIdentity(identity: Identity) {
        console.log("updateIdentity: %o", identity);
        if (!identity) {
            return Promise.reject("No identity provided");
        }

        const resp = await IdentityAPI.update(identity.key,
            identity.name.trim(),
            identity.email.trim(),
            identity.color,
            identity.role,
            identity.verified,
            identity.dedicated,
            identity.phone,
            identity.addr1,
            identity.addr2,
            identity.city,
            identity.state,
            identity.zipcode
        );

        this.receiveUpdate([resp]);
        return resp;
    }

    async updateRole(identityKey: string, role: string) {
		return IdentityAPI.updateRole(identityKey, role).then((resp) => {
            this.receiveUpdate(resp);
            return resp;
        });
    }

    getUserIdentity(key: string) {
        // console.log("we have %d items during getIdentity", this.items.length);
        const ret = this.items.find((c) => c.key === key);
        // console.log("Returning %o, %o", ret?.key, ret);
        return ret as Identity;
    }

	getUserIdentities() : Identity[] {
		return this.items;
	}

	async fetchUserIdentities(cursor = "") {
		return IdentityAPI.list(cursor).then((resp) => {
			this.receiveUpdate(resp.items);
			if(resp.cursor) {
				this.fetchUserIdentities(resp.cursor);
			}
            //  return resp.items;
		})
	}

    updatePresence() {
        // this has very basic throttling, so we don't spam the server.
        if(this.presenceQueueId) {
            // console.log("already scheduled to do this, holding off for now.");
            return;
         }

        // first, check if we the browser thinks the user is active.
        if(!navigator.userActivation) {
            // console.error("not updating presence, no user activation in browser.");
            return;
        }
        if(navigator.userActivation.isActive) {
            this.presenceLastActive = new Date();
        }
        else {
            // console.log("not updating presence, notACtive. : %o", navigator.userActivation);
            return;
        }
        // console.log("updating presence %s", this.presenceLastActive);

        this.presenceQueueId = window.setTimeout(() => {
            if(!this.currentIdentityKey) {
                console.error("I don't have currentIdentityKey (uuid), not updating presence.");
                return;
            }
            this.presenceUpdateCount++;

            // how long since they were last active?
            const now = new Date();
            const diff = (now.getTime() - this.presenceLastActive.getTime());

            /* User has been inactive for TIMEOUT_INTERVAL,
            * not updating presence. */
            if(diff > TIMEOUT_INTERVAL) {
                console.log("User has been inactive for %o seconds, not updating presence.", (diff / 1000.0));
                this.presenceQueueId = 0;
                return;
            }

            // console.log("Running it with diff: %0.02f", ( diff / 1000.0))
            PresenceAPI.set(this.currentIdentityKey).then(() => {
                // console.log("Presence updated: " + this.currentIdentityKey);
                // set this to zero, so we can run again.
                this.presenceQueueId = 0;
            }).
                catch(() => {
                    console.error("Error updating presence: " + this.currentIdentityKey);
                this.presenceQueueId = 0;
                });
        }, this.presenceUpdateCount == 0 ? 0 : TICK_INTERVAL);

    }


    presenceStart() {
        if(!this.presenceTimeoutId) {
            this.presenceTick();
        }
    }

    presenceTick(cnt = 0) {
        if(!this.presenceTimeoutId) {
            //            console.log("ticking presence timer, %d", cnt);
            this.updatePresence()
            this.presenceTimeoutId = window.setTimeout(() => {
                this.presenceTimeoutId = 0;
                this.presenceTick(cnt + 1);
            }, TICK_INTERVAL);
        }
    }

    presenceStop() {
        if(this.presenceTimeoutId) {
            console.debug("(Presence timer stop requested");
            // clearTimeout(this.presenceTimeoutId);
            // this.presenceTimeoutId = 0;
        }
    }

	modelConstructor() {
		return Identity;
	}

}
